import { Router } from './Router'
import { ErrorBoundary } from '../shared/components/ErrorBoundary'
import { AppDialogProvider } from '../shared/dialog/AppDialogContext'

export function Providers() {
  return (
    <ErrorBoundary>
      <AppDialogProvider>
        <Router />
      </AppDialogProvider>
    </ErrorBoundary>
  )
}
